/* eslint arrow-body-style: */
import axios from 'axios';
import config from 'shared/config';
import setBaseRequest from 'shared/utils/setBaseRequest';
import { asyncStart, asyncSuccess, asyncError } from 'redux/domain/AsyncStatus/actions';
import { batchActions } from 'redux-batched-actions';
import keyPath from './keypath';
import { RECEIVE_BRAND_INFO } from './constants';

export const receiveBrandInfo = brandInfo => {
	return {
		type: RECEIVE_BRAND_INFO,
		brandInfo,
	};
};

// Thunks

export const getBrandInfo = asyncId => async dispatch => {
	const asyncKeyPath = keyPath(asyncId, 'getBrandInfo');
	const cancellationSource = axios.CancelToken.source();
	dispatch(asyncStart(asyncKeyPath, cancellationSource));

	let response;
	try {
		response = await axios.get(
			`${config.ESTORIS_BASE_PATH}/GetBrandInfo`,
			setBaseRequest({}, cancellationSource.token),
		);
		dispatch(
			batchActions([
				dispatch(receiveBrandInfo(response.data.brandInfo)),
				dispatch(asyncSuccess(asyncKeyPath)),
			]),
		);
	} catch (error) {
		if (!axios.isCancel(error)) {
			// fetch completed in error
			dispatch(asyncError(asyncKeyPath, error));
		}
	}
	return response;
};
